var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip.bottom",
          value: {
            content: _vm.tooltip,
            container: false,
            delay: { show: 1000 },
          },
          expression:
            "{ content: tooltip, container: false, delay:{ show: 1000 } }",
          modifiers: { bottom: true },
        },
      ],
      staticClass: "item-picker__item d-flex mb-2 p-0",
      class: {
        "item-picker__deselect": _vm.preview === false,
        "not-public": _vm.preview === false,
      },
      on: {
        click: function ($event) {
          return _vm.toggleItem(_vm.item)
        },
      },
    },
    [
      _vm.includeDate === false
        ? [
            _vm.preview === true
              ? _c("b-icon", { attrs: { icon: "check", "font-scale": "2" } })
              : _c("b-icon", { attrs: { icon: "plus", "font-scale": "2" } }),
            _c("span", {
              staticClass: "p-0 pr-2 d-flex align-self-center",
              domProps: {
                innerHTML: _vm._s(
                  "" +
                    _vm.findProp(_vm.item) +
                    _vm.getDisplayLevelText(_vm.item)
                ),
              },
            }),
          ]
        : _vm._e(),
      _vm.includeDate === true
        ? _c("div", { staticClass: "item-picker__display" }, [
            _c(
              "div",
              { staticClass: "item-picker__sub" },
              [
                _vm.preview === true
                  ? _c("b-icon", {
                      attrs: { icon: "check", "font-scale": "2" },
                    })
                  : _c("b-icon", {
                      attrs: { icon: "plus", "font-scale": "2" },
                    }),
                _c("div", {
                  staticClass: "pl-1 d-flex flex-column justify-content-center",
                  domProps: {
                    innerHTML: _vm._s(_vm.getDisplayLevel(_vm.item)),
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass:
                      "date d-flex flex-column justify-content-center",
                  },
                  [
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("moment")(
                            _vm.item.start || _vm.item.Start,
                            "MMM YYYY"
                          )
                        )
                      ),
                    ],
                    (_vm.item.end || _vm.item.End) !== null
                      ? [
                          [_vm._v(_vm._s(" - "))],
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  _vm.item.end || _vm.item.End,
                                  "MMM YYYY"
                                )
                              )
                            ),
                          ],
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }